/* eslint-disable */

import http from './http';
import { AxiosResponse, CancelTokenSource } from 'axios';

class UserService {
  static getUsers(params: {
    page: number;
    limit: number;
    sortBy: string;
    sortDirection: string;
    search: string;
  }): Promise<AxiosResponse> {
    return http.get(
      `/users?page=${params.page}&limit=${params.limit}&sortBy=${params.sortBy}&sortDirection=${params.sortDirection}&search=${params.search}`
    );
  }

  static getUsersSearchNew(search: string) {
    return http.get(`/users/search?email=${search}`);
  }

  static getSubModules() {
    return http.get('/users/sub-modules');
  }
  static getModules() {
    return http.get('/users/module');
  }

  static getAdminModules() {
    return http.get('/users/admin-modules');
  }

  static getAdminModulesByUserId(userId: string) {
    return http.get(`/users/admin-modules/${userId}`);
  }

  static getAdminUsers(params: {
    page: number;
    limit: number;
    sortBy: string;
    sortDirection: string;
    search: string;
  }): Promise<AxiosResponse> {
    return http.get(
      `/users/adminUsers?page=${params.page}&limit=${params.limit}&sortBy=${params.sortBy}&sortDirection=${params.sortDirection}&search=${params.search}`
    );
  }

  static getAdminUsersSupport(params: {
    page: number;
    limit: number;
    sortBy: string;
    sortDirection: string;
    search: string;
  }): Promise<AxiosResponse> {
    return http.get(
      `/users/supportAdminUsers?page=${params.page}&limit=${params.limit}&sortBy=${params.sortBy}&sortDirection=${params.sortDirection}&search=${params.search}`
    );
  }

  static getExternalUsers(params: {
    page: number;
    limit: number;
    sortBy: string;
    sortDirection: string;
  }): Promise<AxiosResponse> {
    return http.get(
      `/users/external?page=${params.page}&limit=${params.limit}&sortBy=${params.sortBy}&sortDirection=${params.sortDirection}`
    );
  }

  static getExternalClientUsers(params: {
    page: number;
    limit: number;
    sortBy: string;
    sortDirection: string;
    search: string;
  }): Promise<AxiosResponse> {
    return http.get(
      `/users/client-external-users?page=${params.page}&limit=${params.limit}&sortBy=${params.sortBy}&sortDirection=${params.sortDirection}&search=${params.search}`
    );
  }

  static resendExistingPasswordSetupLinks(): Promise<AxiosResponse> {
    return http.get('/auth/signup/external-client-users/resend-existing-password-links');
  }
}

export default UserService;
